import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@hbf/dsl';
import { ValuePropositionData } from './types';

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export interface Props {
  valueProposition: ValuePropositionData;
}

export const VpCTATemp: React.FC<Props> = ({
  valueProposition: { linkTitle, linkUrl },
}) => {
  const { classes } = useStyles();
  if (!linkTitle || !linkUrl) return null;
  return (
    <div className={classes.container}>
      <Button href={linkUrl} color="primary" variant="contained" size="large">
        {linkTitle}
      </Button>
    </div>
  );
};
